import React, { Suspense } from "react";
import { render } from "react-dom";
import "./index.scss";
import * as serviceWorker from "./serviceWorker";
import AppRoutes from "./utils/routes";
import firebaseConfig from "./utils/firebase";
import { FirebaseAppProvider } from "reactfire";
import LoaderComponent from "./components/loaderComponent";
import DevIndicator from "./components/DevIndicator";
import { Provider } from "react-redux";
import store from "./utils/store";
import "bootstrap/dist/css/bootstrap.min.css";
import "intl-pluralrules";
import "./styles/styles.scss";
import "./i18n/i18n";
import TagManager from "react-gtm-module";
import smoothscroll from "smoothscroll-polyfill";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
import "./themes/JET/assets/HeadingNow-95Medium.otf"
import { getTheme } from "./themes/themeManager";
import { THEME_PROPERTIES } from "./themes/themes.consts";

const tagManagerArgs = {
    gtmId: "GTM-KB4HZW5",
};

const client = new ApolloClient({
    uri: process.env.REACT_APP_CORE_URL + "/graphql",
    cache: new InMemoryCache(),
    fetchOptions: {
        mode: "no-cors",
    },
});

TagManager.initialize(tagManagerArgs);
smoothscroll.polyfill();

const checkCustomTheme = () => { 
    const customTheme = getTheme(THEME_PROPERTIES.BACKGROUND)
    if (customTheme !== "") {
        document.body.style.backgroundImage = `url(${customTheme})`;
        document.body.style.backgroundSize = "cover";
        document.body.style.backgroundRepeat = "round";

    }
};

checkCustomTheme();
render(
    <div className={`app-style ${!getTheme(THEME_PROPERTIES.IS_DEFAULT) ? "custom-theme" : "default-theme" }`}>
        <Provider store={store}>
            <ApolloProvider client={client}>
                <FirebaseAppProvider firebaseConfig={firebaseConfig}>
                    <Suspense fallback={<LoaderComponent />}>
                        <AppRoutes />
                    </Suspense>
                </FirebaseAppProvider>
            </ApolloProvider>
        </Provider>
        {process.env.REACT_APP_ENV === "dev" ? <DevIndicator /> : ""}
    </div>,
    document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
